import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    services: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "919839586879";

    const message = `New Contact Enquiry 👇
Name: ${form.name}
Mobile: ${form.number}
Services: ${form.services}
Message: ${form.message}`;

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    setForm({
      name: "",
      number: "",
      services: "",
      message: "",
    });
  };

  return (
    <section className="contact-section">
      <h2 className="contact-heading">
        Let's get in <span>touch</span>
      </h2>
      <p className="contact-subheading">
        Have a question, project idea, or need help? Fill out the form or find us
        on the map. We’d love to hear from you.
      </p>

      <div className="contact-container">
        {/* FORM CARD */}
        <div className="contact-card">
          <h3>Send us a message</h3>
          <p className="card-subtitle">
            We usually reply within 24 hours on business days.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="field">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="field">
                <label>Mobile Number</label>
                <input
                  type="tel"
                  name="number"
                  value={form.number}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="field">
              <label>Services</label>
              <input
                type="text"
                name="services"
                value={form.services}
                onChange={handleChange}
              />
            </div>

            <div className="field">
              <label>Message</label>
              <textarea
                rows="4"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
              />
            </div>

            <button className="send-btn">Send message</button>

            <p className="privacy">
              By submitting, you agree to be contacted regarding your inquiry.
            </p>
          </form>
        </div>

        {/* MAP CARD */}
        <div className="map-card">
          <h3>Find us on the map</h3>
          <p className="card-subtitle">
            Visit our office or schedule a meeting at your convenience.
          </p>

          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28679.560378491977!2d83.35919353268231!3d26.035353989552174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399190559a84182f%3A0xcdbbedfebfc5f3e!2sMuhammadabad%20Gohna%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1765629691014!5m2!1sen!2sin"
            loading="lazy"
          ></iframe>

          <div className="map-info">
            <p>Uttar Pradesh</p>
            <p>Mon – Sat · 9:30 AM – 6:30 PM</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
